import { useEffect, useRef } from "react"

export function useInfiniteScroll({
  hasNextPage,
  isFetchingNextPage,
  isError = false,
  fetchNextPage,
}: {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  isError?: boolean
  fetchNextPage: () => void
}) {
  const sentinelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = sentinelRef.current
    if (!el || !hasNextPage || isError) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage()
        }
      },
      { threshold: 0.1 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [hasNextPage, isFetchingNextPage, isError, fetchNextPage])

  return sentinelRef
}
